<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid text-center" style="background-color: white; padding: 20px">
            <div class="row form-group">
                <div :class="labelCol">
                    <label>รหัสสินค้าโรงงาน </label>
                </div>
                <div :class="inputCol">
                    <input type="text" class="form-control" v-model="form.code"/>
                </div>
            </div>
            <div class="row form-group">
                <div :class="labelCol">
                    <label>ชื่อสินค้าโรงงาน</label>
                </div>
                <div :class="inputCol">
                    <input type="text" class="form-control" v-model="form.name"/>
                </div>
            </div>
            <div class="row form-group">
                <div :class="labelCol">
                    <label>ราคาขาย/หน่วย</label>
                </div>
                <div :class="inputCol">
                    <input type="text" class="form-control" v-model="form.price"/>
                </div>
            </div>
            <div class="col text-center">
                <button type="button" class="btn btn-success" @click="saveFactory">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp;&nbsp;
                <button class="btn btn-outline-secondary" @click="goToFactoryTable">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
                &nbsp;&nbsp;
                <b-button variant="danger"
                          v-if="form.id && !form.active"
                          @click="showModalDelete(form.id)">
                    <icon name="trash-alt" style="width: 25px"></icon>
                    InActive
                </b-button>
                <b-button variant="success"
                          v-else-if="form.id && form.active"
                          @click="showModalDelete(form.id)">
                    Active
                </b-button>
            </div>
        </div>
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการเปลี่ยนสถานะใช่ไหม?</h4>
                <br />
                <button @click="deleteData"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideModalDelete"
                        type="button"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import DeleteConfirmModal from "../Utility/DeleteConfirmModal";

    export default {
        name: "Factory-form",
        components: {DeleteConfirmModal},
        data(){
            return {
                inputCol : 'col-6 col-xs-12',
                labelCol : 'col-4 col-xs-12 text-right',
                items: [
                    {
                        text: "รายการสินค้าโรงงาน",
                        to: { name: "factory-product" }
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
                id : ''
            }
        },
        created() {
        },
        computed:{
            ...mapState({
                form : state=>{
                    return state.FactoryEmployee.form
                }
            })
        },
        methods:{
            showModalDelete(id) {
                this.id = id;
                this.$refs.delete_item.show();
            },
            hideModalDelete() {
                this.$refs.delete_item.hide();
            },
            deleteData() {
                this.$store.dispatch("FactoryEmployee/delete", this.id).then(() => {
                    this.hideModalDelete()
                    this.$forceUpdate();
                });
            },
            saveFactory(){
                if(!this.form.code){
                    alert('กรุณากรอกรหัสสินค้าโรงงาน');
                }else if(!this.form.name){
                    alert('กรุณากรอกชื่อสินค้าโรงงาน');
                }else{
                    this.$store.dispatch("FactoryEmployee/saveFactoryEmployee",{
                        id : this.form.id,
                        data : this.form
                    }).then(()=>{
                        this.goToFactoryTable();
                    }).catch(err=>{
                        alert('บันทึกข้อมูลไม่สำเร็จ');
                    })
                }
            },
            goToFactoryTable(){
                this.$router.push("/factory-product")
            },
        },
    }
</script>

<style scoped>
</style>
